
















import {Component, Vue} from 'vue-property-decorator';
import Navigation from "@/components/Navigation.vue";

import routes from '@/router/main';

@Component({
    components: {Navigation}
})
export default class App extends Vue {
    private routes = routes;
}
